<button
  class="chatbot-fab"
  type="button"
  [class.chatbot-fab--dragging]="isDragging"
  [style.left.px]="posX"
  [style.top.px]="posY"
  [attr.aria-label]="'OpenAICounselor' | translate"
  (pointerdown)="onPointerDown($event)"
  (pointermove)="onPointerMove($event)"
  (pointerup)="onPointerUp($event)"
  (click)="onClick()">
  <img [src]="botAvatarUrl" alt="" draggable="false" />
</button>
